import { initSubRoutes } from '../../../utils/router';

const RoutesGuideUtilisateurSIA = initSubRoutes({
    route: '/aide',
    subroutes: {},
    nom: 'Guide utilisateur',
});

export default RoutesGuideUtilisateurSIA;
